@if (pages.length > 1) {
  <kb-hero-carousel [pages]="pages" abstractMode="button"></kb-hero-carousel>
} @else {
  <kb-hero-item [item]="pages[0]" [rootColumns]="12" abstractMode="button"></kb-hero-item>
}
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
